import { memo } from "react";

const Bars = memo(function Bars({
  data,
  xScale,
  yScale,
  styles,
  animation,
  animated,
  onBarEnter,
  onBarMove,
  onBarLeave,
  activeBar,
  series,
}) {
  return (
    <>
      {data.map((d, i) => {
        const isActive = activeBar === d.label;

        return (
          <rect
            key={d.label}
            x={1 - (isActive ? 1 : 0)}
            y={yScale(d.label) - (isActive ? 1 : 0)}
            width={(animated ? xScale(d.values[0]) : 0) + (isActive ? 2 : 0)}
            height={yScale.bandwidth() + (isActive ? 2 : 0)}
            rx={styles.rx}
            fill={activeBar === d.label ? styles.hoverFill : styles.fill}
            style={{
              cursor: "pointer",
              transition: `
                width ${animation.duration}s ease ${i * animation.stagger}ms,
                y 0.15s ease,
                height 0.15s ease,
                fill 0.15s ease
              `,
            }}
            onMouseEnter={(e) => onBarEnter(d, e)}
            onMouseMove={(e) => onBarMove(d, e)}
            onMouseLeave={onBarLeave}
          />
        );
      })}
    </>
  );
});

const StackedBars = memo(function StackedBars({
  data,
  xScale,
  yScale,
  styles,
  animation,
  animated,
  onBarEnter,
  onBarMove,
  onBarLeave,
  activeBar,
  activeSegment,
  series,
}) {
  return (
    <>
      {data.map((d, i) => {
        let accumulatedWidth = 0; // Acumulador para x de cada segmento

        return d.values.map((v, j) => {
          // Calculo del segmento actual
          const xPosition = 1 + accumulatedWidth;
          const barWidth = xScale(v);
          const isActive =
            activeBar === d.label && activeSegment === series[j].name;

          accumulatedWidth += barWidth;

          return (
            <rect
              key={`${d.label}-${series[j].name}`}
              x={xPosition - (isActive ? 1 : 0)}
              y={yScale(d.label) - (isActive ? 1 : 0)}
              width={(animated ? barWidth : 0) + (isActive ? 2 : 0)}
              height={yScale.bandwidth() + (isActive ? 2 : 0)}
              rx={styles.rx}
              fill={
                activeBar === d.label && activeSegment === series[j].name
                  ? series[j].hoverColor
                  : series[j].color
              }
              style={{
                cursor: "pointer",
                transition: `
                  width ${animation.duration}s ease ${
                  i * animation.stagger + j * animation.duration * 1000
                }ms,
                y 0.15s ease,
                height 0.15s ease,
                  fill 0.15s ease
                `,
              }}
              onMouseEnter={(e) =>
                onBarEnter({ ...d, segment: series[j], v }, e)
              }
              onMouseMove={(e) => onBarMove(d, e)}
              onMouseLeave={onBarLeave}
            />
          );
        });
      })}
    </>
  );
});

const GroupedBars = memo(function GroupedBars({
  data,
  xScale,
  yScale,
  styles,
  animation,
  animated,
  onBarEnter,
  onBarMove,
  onBarLeave,
  activeBar,
  activeSegment,
  series,
}) {
  const subHeight = yScale.bandwidth() / series.length; // Altura de cada barra dentro del grupo
  return (
    <>
      {data.map((d, i) => {
        return d.values.map((v, j) => {
          // Calculo del segmento actual
          const barWidth = xScale(v);
          const isActive =
            activeBar === d.label && activeSegment === series[j].name;

          return (
            <rect
              key={`${d.label}-${series[j].name}`}
              x={1 - (isActive ? 1 : 0)}
              y={yScale(d.label) + j * subHeight - (isActive ? 1 : 0)}
              width={(animated ? barWidth : 0) + (isActive ? 2 : 0)}
              height={subHeight + (isActive ? 2 : 0)}
              rx={styles.rx}
              fill={
                activeBar === d.label && activeSegment === series[j].name
                  ? series[j].hoverColor
                  : series[j].color
              }
              style={{
                cursor: "pointer",
                transition: `
                  width ${animation.duration}s ease ${
                  i * animation.stagger + j * animation.duration * 1000
                }ms,
                y 0.15s ease,
                height 0.15s ease,
                  fill 0.15s ease
                `,
              }}
              onMouseEnter={(e) =>
                onBarEnter({ ...d, segment: series[j], v }, e)
              }
              onMouseMove={(e) => onBarMove(d, e)}
              onMouseLeave={onBarLeave}
            />
          );
        });
      })}
    </>
  );
});

export { Bars, StackedBars, GroupedBars };
